export const getLocalState = (globalPath: string) => {
  const globalPaths = globalPath.split('/');
  return globalPaths[globalPaths.length - 1];
};
